/**
 * __DAY_GRAPH__ (2026-10-20) Settings -> Day graph: the graph's columns (day start / end, Toronto time) and whether the
 * empty time before the first job / after the last job is hidden. Kept on the hub, so the Dispatch app's Day graph
 * uses the same. Saving needs the owner / CEO.
 */
import React, { useEffect, useState } from 'react';
import { fetchDayGraph, saveDayGraphSettings } from '../services/dayGraphService';
import { torontoDay } from '../utils/dayGraph';

function DayGraphSettings() {
  const [s, setS] = useState(null);
  const [canEdit, setCanEdit] = useState(false);
  const [msg, setMsg] = useState('');
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    fetchDayGraph(torontoDay(), false).then((r) => {
      if (r.ok) { setS(r.graph.settings); setCanEdit(!!r.graph.can_edit_settings); } else setMsg(r.message);
    });
  }, []);

  const save = async () => {
    setSaving(true);
    const r = await saveDayGraphSettings(s);
    setSaving(false);
    if (r.ok) { setS(r.settings); setMsg('✓ Saved. The board and the Dispatch app use it from their next refresh.'); } else setMsg('Not saved — ' + r.message);
  };

  const row = { display: 'flex', alignItems: 'center', gap: '0.75rem', marginBottom: '0.75rem', fontSize: '0.9rem' };
  const input = { padding: '0.35rem 0.5rem', borderRadius: 5, border: '1px solid var(--border-default)', background: 'var(--surface-1, var(--bg-primary))', color: 'var(--text-primary)' };
  return (
    <div data-day-graph-settings>
      <div style={{ marginBottom: '1rem', padding: '1rem', backgroundColor: 'var(--surface-2)', borderRadius: 5, fontSize: '0.9rem', color: 'var(--text-muted)' }}>
        View → Day graph: drivers as rows, their jobs placed on the day's hours, a needle at the time now. These settings are the
        same for this site and the Dispatch app (Toronto time).
      </div>
      {!s ? <div style={{ color: 'var(--text-muted)' }}>{msg || 'Loading…'}</div> : (
        <div>
          <div style={row}><label style={{ width: 220 }}>Day starts at</label>
            <input type="time" value={s.day_start} disabled={!canEdit} onChange={(e) => setS({ ...s, day_start: e.target.value })} style={input} /></div>
          <div style={row}><label style={{ width: 220 }}>Day ends at</label>
            <input type="time" value={s.day_end} disabled={!canEdit} onChange={(e) => setS({ ...s, day_end: e.target.value })} style={input} /></div>
          <div style={row}><label><input type="checkbox" checked={!!s.hide_before} disabled={!canEdit} onChange={(e) => setS({ ...s, hide_before: e.target.checked })} />{' '}
            Hide the empty time before the first job</label></div>
          <div style={row}><label><input type="checkbox" checked={!!s.hide_after} disabled={!canEdit} onChange={(e) => setS({ ...s, hide_after: e.target.checked })} />{' '}
            Hide the empty time after the last job</label></div>
          <div style={{ fontSize: '0.8rem', color: 'var(--text-muted)', marginBottom: '0.75rem' }}>
            Jobs outside these hours still show (the columns widen to them). On today the needle is never hidden.
          </div>
          {canEdit ? <button onClick={save} disabled={saving} style={{ padding: '0.5rem 1rem', borderRadius: 5, border: 'none', background: 'var(--accent-blue, #1f6feb)', color: '#fff', cursor: 'pointer' }}>{saving ? 'Saving…' : 'Save'}</button>
            : <div style={{ fontSize: '0.85rem', color: 'var(--text-muted)' }}>Only the owner / CEO can change these.</div>}
          {!!msg && <div style={{ marginTop: '0.75rem', fontSize: '0.85rem' }}>{msg}</div>}
        </div>
      )}
    </div>
  );
}

export default DayGraphSettings;
